// userApi.js
import {getRequest, refreshToken, sendRequest} from './api';
import {getPayload} from '../utils/getPayload';

let isAuthenticated = false;
const subscribers = new Set();

export function subscribeAuth(cb) {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}

function updateAuthState(newState) {
  if (isAuthenticated !== newState) {
    isAuthenticated = newState;
    subscribers.forEach((cb) => cb(isAuthenticated));
  }
}

export async function fetchUser(id) {
  return getRequest(`/api/user?id=${id}`);
}

export async function loginUser(login, password) {
  return sendRequest('/session/login', 'POST', {login, password});
}

export async function registerUser(data) {
  return sendRequest('/user', 'POST', data);
}

export async function logoutUser(data) {
  return sendRequest('/session/logout/all', 'POST', data);
}

export async function registrationOrganisation(data) {
  return sendRequest('/organisation', 'POST', data);
}

export async function fetchCompanyDataByINN(inn) {
  return sendRequest('/organisation/fillbyinn', 'POST', {inn});
}

export async function fetchCompanyDataByBIK(bik) {
  return sendRequest('/organisation/fillbybik', 'POST', {bik});
}

// cookie helpers (только чтение)
export function getCookie(name) {
  const m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[2]) : null;
}

export function getTokensFromCookies() {
  return {
    a_token: getCookie('a_token'),
    r_token: getCookie('r_token'),
  };
}

let refreshPromise = null;

export const checkRefreshToken = async () => {
  const {a_token, r_token} = getTokensFromCookies();
  if (!a_token || !r_token) return false;

  const {iat, exta} = getPayload(a_token);

  const now = Math.floor(Date.now() / 1000);

  // access token ещё жив
  if (iat + (exta - iat) * 0.5 > now) {
    updateAuthState(true);
    return true;
  }

  // refresh уже идёт
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      // вызываем refresh — куки обновит сервер
      await refreshToken({a_token, r_token});
      updateAuthState(true);
      return true;
    } catch {
      updateAuthState(false);
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};
